import { lastDueStaffPeriod, type StartingPointSettings } from "@shared/staff-starting-point";
import { staffToday } from "@/lib/staff-identity";
export type StartingPointFields = { paidUpTo?:string|null; paidUpToDefault?:string|null };
export type StartingPointBootstrap = { paySettings?:StartingPointSettings };
export type StartingPointSelection = {mode:"default"|"never"|"date";date:string};
export const initialStartingPoint:StartingPointSelection={mode:"default",date:""};
export const startingFields=(value:object)=>value as StartingPointFields;
export function effectivePaidTo(employee:{lastPaidTo?:string|null}&StartingPointFields) {
  return [employee.lastPaidTo,employee.paidUpTo].filter((d):d is string=>!!d).map(d=>d.slice(0,10)).sort().at(-1)||null;
}
export const neverPaid=(employee:{lastPaidTo?:string|null}&StartingPointFields)=>!effectivePaidTo(employee);
export function validStartingDate(date:string,hireDate:string,today:string) {
  return /^\d{4}-\d{2}-\d{2}$/.test(date)&&!Number.isNaN(Date.parse(`${date}T00:00:00Z`))&&new Date(`${date}T00:00:00Z`).toISOString().slice(0,10)===date&&date>=hireDate.slice(0,10)&&date<=today;
}
export function startingPointBody(selection:StartingPointSelection,oldHire:boolean):{paidUpTo?:string|null} {
  if(!oldHire||selection.mode==="default")return {};
  return {paidUpTo:selection.mode==="never"?null:selection.date};
}
export function creationDefault(source:object,per:"month"|"day") {
  const data=source as StartingPointBootstrap;
  return data.paySettings?lastDueStaffPeriod(staffToday(),per,data.paySettings):null;
}
export function staffInitials(name:unknown):string|null {
  if(typeof name!=="string")return null;
  const words=name.normalize("NFC").trim().split(/\s+/).filter(Boolean).slice(0,2);
  if(!words.length)return null;
  const Segmenter=(Intl as unknown as {Segmenter?:new(locale?:string,options?:{granularity:string})=>{segment:(value:string)=>Iterable<{segment:string}>}}).Segmenter;
  const first=(word:string)=>Segmenter?[...new Segmenter(undefined,{granularity:"grapheme"}).segment(word)][0]?.segment:Array.from(word)[0];
  const letters=words.map(first);
  return letters.every(letter=>!!letter&&/\p{L}/u.test(letter))?letters.join(""):null;
}
const translations:Record<string,string>={
  "Paid up to":"مدفوع حتى","before Infrastock":"قبل إنفراستوك","Change starting point":"تغيير نقطة البداية","Set paid up to…":"تحديد تاريخ المدفوع حتى…",
  "Paid up to the last pay day":"مدفوع حتى آخر موعد صرف","Set paid up to last pay day":"تحديد المدفوع حتى آخر موعد صرف","Never paid by us":"لم نصرف له من قبل","Pick a date":"اختيار تاريخ",
  "Starting point only. No payment, cash movement or pay record will be created.":"نقطة بداية فقط. لن يتم إنشاء دفعة أو حركة نقدية أو سجل صرف.",
  "Save starting point":"حفظ نقطة البداية","Cancel":"إلغاء","Saving…":"جارٍ الحفظ…","Retry":"إعادة المحاولة",
  "This person has an Infrastock pay record after this date.":"يوجد سجل صرف في إنفراستوك لهذا الشخص بعد هذا التاريخ.",
  "Choose a date between the hire date and today.":"اختر تاريخًا بين تاريخ بدء العمل واليوم.",
  "Smart server default":"تاريخ افتراضي يحسبه النظام","Starting point set during onboarding":"تم تحديد نقطة البداية أثناء إضافة الموظفين",
};
export const startingText=(value:string,rtl:boolean)=>rtl?(translations[value]||value):value;
export const startingCheck=(date:string,rtl:boolean)=>rtl?`تحقق: هل لم يُصرف لهذا الشخص منذ ${date} فعلًا؟`:`Check: is this person really unpaid since ${date}?`;
